module.exports = __webpack_public_path__ + "static/scopriabitareco_business-unit-ebdfb7ad2254a69f35a56479c729a339.jpg";